<template>
  <div>
           <v-alert 
      v-model="showAlert"
      :dismissible="true"
      :type="typeofbox"     
      class="mb-4"
    >{{name}}<br>{{message}}</v-alert>
  <form>

    <v-text-field  :dark="isDarkDark"
      v-model="name"
      :error-messages="nameErrors"
      :counter="40"
      label="Name"
      required
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
    ></v-text-field>
    <v-text-field :dark="isDarkDark"
      v-model="email"
      :error-messages="emailErrors"
      label="E-mail"
      required
      @input="$v.email.$touch()"
      @blur="$v.email.$touch()"
    ></v-text-field>
    <v-select :dark="isDarkDark"
      v-model="select"
      :items="items"
      :error-messages="selectErrors"
      label="Industry"
      required
      @change="$v.select.$touch()"
      @blur="$v.select.$touch()"
    ></v-select>

    <v-btn center class="mr-5" @click="submit">Stay In Touch</v-btn>
    <!-- <v-btn @click="clear">clear</v-btn> -->
  </form>
</div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import Vue from 'vue'
const fb = require('../firebaseConfig.js')

  export default {
    mixins: [validationMixin],
 props: {
  
    isdark:
   {
   default: "TEST"
    }
 },

    validations: {
      name: { required, maxLength: maxLength(40) },
      email: { required, email },
      select: { required },
    },

    data: () => ({
      isDarkDark:false,
        showAlert:false,
    message:'',
    typeofbox:"success",
      name: '',
      email: '',
      select: null,
      items: [
        'Retail Investor',
        'Prop Firm',
        'Hedge Fund',
        'Academic',
        'Trader Arcade'
      ],
      isDarkCopy: false,
    }),
    watch:{
      isdark(val){
          alert(val)
      }
    },
    computed: {
      checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        !this.$v.checkbox.checked && errors.push('You must agree to continue!')
        return errors
      },
      selectErrors () {
        const errors = []
        if (!this.$v.select.$dirty) return errors
        !this.$v.select.required && errors.push('Industry is required')
        return errors
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push('Name must be at most 40 characters long')
        !this.$v.name.required && errors.push('Name is required.')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Must be valid e-mail')
        !this.$v.email.required && errors.push('E-mail is required')
        return errors
      },
    },

    methods: {
        async signup(){
            try{
            var user = await fb.auth.createUserWithEmailAndPassword(this.email,"021efa625da743b386028d2b5d8c094d")
           
         //   this.$store.commit('setCurrentUser', user.user);
          //  this.$store.dispatch('fetchUserProfile');              
              //create user obj
             await  fb.usersCollection.doc(user.user.uid).set({
                name: this.name,
                industry: this.select,
                editorEnabled: false,
              });
                this.typeofbox = "success";
                this.message = "Thank You For Registering. Our Team Will Contact You Shortly";
            }
            catch(err){ 
              this.typeofbox = "error";
              this.message = err.message;

              console.log(err)
            }
            this.showAlert = true;
        },
      submit () {
       this.signup()
      },
      clear () {
        this.$v.$reset()
        this.name = ''
        this.email = ''
        this.select = null
        this.checkbox = false
      },
    },
  }
</script>